module.exports = __webpack_public_path__ + "static/media/logo-ue-leader.a50bb5a9.jpg";